var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7923 2.19727C8.50492 2.19727 2.57495 8.12577 2.57495 15.4147C2.57495 22.7035 8.50492 28.6321 15.7923 28.6321C23.0798 28.6321 29.0097 22.7035 29.0097 15.4147C29.0097 8.12577 23.0812 2.19727 15.7923 2.19727ZM15.7923 27.3956C9.18583 27.3956 3.81139 22.0212 3.81139 15.4147C3.81139 8.80815 9.18583 3.43371 15.7923 3.43371C22.3989 3.43371 27.7733 8.80815 27.7733 15.4147C27.7733 22.0212 22.3989 27.3956 15.7923 27.3956Z",
    fill: "#5CB747"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9438 11.0332C20.7178 11.0332 20.5064 11.1207 20.346 11.2811L13.8707 17.7564L11.2374 15.1231C11.077 14.9642 10.8656 14.8752 10.6396 14.8752C10.4136 14.8752 10.2007 14.9627 10.0418 15.1231C9.7123 15.4526 9.7123 15.9892 10.0418 16.3187L13.2729 19.5498C13.4318 19.7087 13.6447 19.7977 13.8707 19.7977C14.0967 19.7977 14.3081 19.7102 14.4685 19.5498L21.5416 12.4767C21.702 12.3163 21.7895 12.1049 21.7895 11.8789C21.7895 11.6529 21.702 11.44 21.5416 11.2811C21.3827 11.1207 21.1698 11.0332 20.9438 11.0332Z",
    fill: "#5CB747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCheck);
export default __webpack_public_path__ + "static/media/alert-check.637a4f0ff400b581924549dd9c6c641d.svg";
export { ForwardRef as ReactComponent };